export const oidcSettings = {
    responseType: "id_token token",
    scope: "openid profile",
    automaticSilentRenew: true,
    automaticSilentSignin: true,
};

export enum EnvType {
    local = "LOCAL",
    localci = "LOCALCI",
    localqa = "LOCALQA",
    localuat = "LOCALUAT",
    ci = "CI",
    qa = "QA",
    uat = "UAT",
    prod = "PROD",
}

export interface OidcSettings {
    env: EnvType;
    authority: string;
    clientId: string;
    redirectUri: string;
    documents: string;
    googleAnalyticsId: string;
}

export interface OidcEnvironments {
    local: OidcSettings;
    localci: OidcSettings;
    localqa: OidcSettings;
    localuat: OidcSettings;
    ci: OidcSettings;
    qa: OidcSettings;
    uat: OidcSettings;
    prod: OidcSettings;
}

export const oidcEnvironments: OidcEnvironments = {
    local: {
        env: EnvType.local,
        authority: "https://localhost:44351",
        clientId: "LOSApplication",
        redirectUri: "https://localhost:44370/oidc-callback",
        documents: "https://localhost:44666",
        googleAnalyticsId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID_DEV,
    },
    localci: {
        env: EnvType.localci,
        authority: "https://identity-dev.studentchoice.org",
        clientId: "los-application",
        redirectUri: "https://localhost:44375/oidc-callback",
        documents: "https://app-lz02-ci-docupl-eus.azurewebsites.net",
        googleAnalyticsId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID_DEV,
    },
    localqa: {
        env: EnvType.localqa,
        authority: "https://identity-qa.studentchoice.org",
        clientId: "los-application",
        redirectUri: "https://localhost:44376/oidc-callback",
        documents: "https://app-lz02-qa-docupl-eus.azurewebsites.net",
        googleAnalyticsId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID_DEV,
    },
    localuat: {
        env: EnvType.localuat,
        authority: "https://identity-uat.studentchoice.org",
        clientId: "los-application",
        redirectUri: "https://localhost:44382/oidc-callback",
        documents: "https://upload.uat.opalsystems.org",
        googleAnalyticsId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID_DEV
    },
    ci: {
        env: EnvType.ci,
        authority: "https://identity-dev.studentchoice.org",
        clientId: "los-application",
        redirectUri: "https://app-lz02-ci-losptl-eus.azurewebsites.net/oidc-callback",
        documents: "https://app-lz02-ci-docupl-eus.azurewebsites.net",
        googleAnalyticsId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID_DEV,
    },
    qa: {
        env: EnvType.qa,
        authority: "https://identity-qa.studentchoice.org",
        clientId: "los-application",
        redirectUri: "https://app-lz02-qa-losptl-eus.azurewebsites.net/oidc-callback",
        documents: "https://app-lz02-qa-docupl-eus.azurewebsites.net",
        googleAnalyticsId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID_PROD,
    },
    uat: {
        env: EnvType.uat,
        authority: "https://identity-uat.studentchoice.org",
        clientId: "los-application",
        redirectUri: "https://los.uat.opalsystems.org/oidc-callback",
        documents: "https://upload.uat.opalsystems.org",
        googleAnalyticsId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID_DEV,
    },
    prod: {
        env: EnvType.prod,
        authority: "https://identity.studentchoice.org",
        clientId: "los-application",
        redirectUri: "https://los.opalsystems.org/oidc-callback",
        documents: "https://upload.opalsystems.org",
        googleAnalyticsId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID_PROD,
    },
};

export function getEnvironment(): OidcSettings {
    // default to PROD
    let environment = oidcEnvironments.prod;
    const host = window.location.hostname;
    const port = window.location.port;

    if (host.includes("localhost") && port === "44370") {
        environment = oidcEnvironments.local;
    } else if (host.includes("localhost") && port === "44375") {
        console.log("Local CI Config loaded");
        environment = oidcEnvironments.localci;
    } else if (host.includes("localhost") && port === "44376") {
        console.log("Local QA Config loaded");
        environment = oidcEnvironments.localqa;
    } else if (host.includes("localhost") && port === "44382") {
        console.log("Local UAT Config loaded");
        environment = oidcEnvironments.localuat;
    } else if (host.includes("-ci")) {
        environment = oidcEnvironments.ci;
    } else if (host.includes("-qa")) {
        environment = oidcEnvironments.qa;
    } else if (host.includes("-uat") || host.includes(".uat.")) {
        environment = oidcEnvironments.uat;
    }

    // disable logging for UAT and PROD environments
    if (environment.env === EnvType.uat || environment.env === EnvType.prod) {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        console.log = () => { };
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        console.warn = () => { };
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        console.debug = () => { };
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        console.info = () => { };
    }

    return environment;
}